import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Box, Skeleton, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import HelpIcon from '@mui/icons-material/Help';
import uniqWith from 'lodash/uniqWith';

import { MapContainer, Marker, GeoJSON } from '../../../../../Maps';
import usePostsQuery from '../../../../../../Hooks/usePostsQuery';
import Tooltip from '../../../../../DesignSystem/Tooltip';
import { postPath } from '../../../../../../Utils/routes';
import { PostTypes } from '../../../../../../Utils/Types';
import { getFiltersValues } from '../../../../../../Utils/filters';

const StyledMapContainer = styled(MapContainer)(({ theme }: any) => ({
  width: '100%',
  height: 450,
  borderRadius: theme.shape.borderRadius,
}));

function TabPostsMap({ parentId, space, iVotedFor, status, geojson }: any) {
  const { posts, isFetching } = usePostsQuery(`children-of-${parentId}`, {
    space,
    parentId,
    iVotedFor,
    status,
    types: [PostTypes.IDEA],
    extraParams: {
      payload: 'map',
      filter: {
        ...getFiltersValues(),
      },
    },
  });
  const postsWithGeo = posts.filter((post: any) => post.lat && post.lng);
  const bounds = postsWithGeo.map((post: any) => [post.lat, post.lng]);

  if (isFetching) {
    return (
      <Box sx={{ mt: 15.5, p: 3 }}>
        <Skeleton variant="rounded" width="100%" height={450} />
      </Box>
    );
  }

  return (
    <>
      <Box
        sx={{
          pb: 3,
          px: 2,
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Typography
          variant="body1"
          component="p"
          sx={{
            fontWeight: 'bold',
          }}
        >
          <FormattedMessage
            id="POSTS.CONSULTATIONS.FEED_TITLE.LOCATED_IDEAS_COUNT"
            values={{
              itemCount: uniqWith(postsWithGeo, (a, b) => a.id === b.id).length || 0,
            }}
          />
        </Typography>

        <Tooltip
          title={
            <Typography variant="body1" color="textPrimary">
              <FormattedMessage id="POSTS.CONSULTATIONS.MAP_TOOLTIP" />
            </Typography>
          }
          icon={<HelpIcon color="action" fontSize="small" />}
        />
      </Box>
      {(postsWithGeo.length > 0 || geojson) && (
        <Box
          sx={{
            pb: 3,
            px: { xs: 0, sm: 3 },
          }}
        >
          <StyledMapContainer bounds={bounds} geojson={geojson}>
            {postsWithGeo.map((post: any) => (
              <Marker
                key={`${post.id}-${post.lat}-${post.lng}`}
                position={[post.lat, post.lng]}
                title={post.title}
                href={postPath(space.slug, post.slug)}
                status={post.status}
              />
            ))}

            {geojson && <GeoJSON data={geojson} />}
          </StyledMapContainer>
        </Box>
      )}
    </>
  );
}

export default TabPostsMap;
